import type { ExtendedApplication } from '../model/application';
import type { FindApplicationsRequestParams } from '../model/find-applications-params';
import type { FindApplicationsResponse } from '../model/find-applications-response';

export interface ApplicationsApi {
  findApplications: (
    params: FindApplicationsRequestParams
  ) => Promise<FindApplicationsResponse>;
  getApplicationById: (applicationId: string) => Promise<ExtendedApplication>;
  generateReport: (
    params: FindApplicationsRequestParams
  ) => Promise<{ reportId: string }>;
}

export const APPLICATIONS_API_KEY = 'applicationsApi';
